// extracted by mini-css-extract-plugin
module.exports = {"colored":"Service_colored__246K-","link_list":"Service_link_list__2C5eB"};